/**
 * 该文件存放发送资料相关页面路由
 */

const sendPaperRoutes = [
  {
    path: '/',
    component: () => import('@/homepage'),
    children: [
      // 新建资料
      {
        path: '/add-papers',
        name: 'addPapers',
        meta: {
          menuName: 'esign-add'
        },
        component: () => import('@/pages/sendPapers/add-papers')
      },
      // 签章发送
      {
        path: '/send-signature',
        name: 'SendSignature',
        meta: {
          menuName: 'esign-send',
        },
        component: () => import('@/pages/sendPapers/sendSignature')
      },
    ]
  }
];

export default sendPaperRoutes;
